import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { devices } from '../constant';

const HeaderContainer = styled.header`
    width: 100%;
    border-bottom: 4px dotted black;
`;

const Logo = styled.span`
    font-family: 'Hanalei', cursive;
    font-size: calc(28px + 2.5vw);
`;

const ActionWrapper = styled.div`
    display: flex;
    margin: 1rem;
    justify-content: space-between;

    @media ${devices.tablet} {
        flex-direction: column;
        align-items: center;
    }
`;

export const HeaderLink = styled(Link)`
    cursor: pointer;
    align-self: center;
    text-decoration: none;
    border: 2px solid black;
    color: black;
    font-size: 1.5rem;
    padding: 6px;
    border-radius: 10px;
    margin-right: 2rem;
    
    @media ${devices.tablet} {
        font-size: 1rem;
        margin-right: 1rem;
        border: 1px solid black;
    }
`;

export const HeaderButton = styled.button`
    cursor: pointer;
    align-self: center;
    text-decoration: none;
    border: 2px solid black;
    color: ${({ isLogout }) => isLogout ? 'white' : 'black'};
    background-color: ${({ isLogout }) => isLogout ? 'red' : null};
    font-size: 1.5rem;
    padding: 6px;
    border-radius: 10px;
    margin-right: 2rem;

    @media ${devices.tablet} {
        font-size: 1rem;
        margin-right: 1rem;
        border: 1px solid black;
    }
`;

export const ActionContainer = styled.div`
    margin-top: 1rem;
`;

const Appbtn = styled(Link)`
    text-decoration: none;
    color: #ffffff;
    padding: 8px 60px;
    font-size: 1.5em;
    border: none;
    border-radius: 20px;
    background-color: #000000;
`;

export const Header = ({ actions }) => {
    return (
        <HeaderContainer>
            <ActionWrapper>
                <Logo>Akshat Soni</Logo>
                <ActionContainer>
                    {actions}
                    <Appbtn to='salaryclc'>App</Appbtn>
                </ActionContainer>
            </ActionWrapper>
        </HeaderContainer>
    );
};
